import React, { useEffect, useState } from 'react'
import { GET_TICKET_BY_STATUS_INPUT } from '../../../graphql/query'
import { useQuery } from '@apollo/client'
import { Dropdown, Empty, Menu, Modal } from 'antd'
import EditTicketModal from './EditTicketModal'
import './styles.scss'
import CreateTicketAdmin from './CreateTicketAdmin'
import LoadingSpinner from '../../LoadingSpinner'
import TicketCount from './TicketCount'
import { usePlan } from '../../../context/PlanContext'
import { v4 as uuidv4 } from 'uuid'

interface MenuItem {
  label: string
  key: string
  title: string
}

const items: MenuItem[] = [
  {
    label: 'null',
    title: 'Select Status',
    key: '1'
  },
  {
    label: 'OPEN',
    title: 'Open',
    key: '2'
  },

  {
    label: 'RESOLVED',
    title: 'Resolved',
    key: '4'
  },

  {
    label: 'INPROGRESS',
    title: 'In-progress',
    key: '3'
  },
  {
    label: 'ASSIGN',
    title: 'Assign',
    key: '5'
  },

  {
    label: 'UNASSIGN',
    title: 'Not Assigned',
    key: '6'
  }
]

const TicketsData = () => {
  const [ticketData, setTicketData] = useState([])
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [editTicketData, setEditTicketData] = useState([])
  const [isBgAccountId, setBgAccountId] = useState(null)
  const [isCreateTicketModalOpen, setIsCreateTicketModalOpen] = useState(false)
  const [selectedStatus, setSelectedStatus] = useState<any>(null)
  const [searchQuery, setSearchQuery] = useState<any>('')
  const [priority, setPriority] = useState<any>(null)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const { data1 } = usePlan()
  console.log(data1?.getBgAccountById?.id)

  const showEnteries = 10
  const {
    data: data2,
    loading: loading1,
    refetch: refetch1
  } = useQuery(GET_TICKET_BY_STATUS_INPUT, {
    variables: {
      input: {
        Status: selectedStatus,
        query: searchQuery,
        Priority: priority,
        bgaccountId: parseInt(data1?.getBgAccountById?.id),
        limit: showEnteries,
        offset: (currentPage - 1) * showEnteries
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Admin-Tickets'
      }
    }
  })

  const openEditModal = (curEl: any) => {
    setIsEditModalOpen(true)
    setEditTicketData(curEl)
  }

  const closeEditModal = () => {
    setIsEditModalOpen(false)
  }

  const createTicketModalOpen = () => {
    setIsCreateTicketModalOpen(true)
  }

  const createTicketModalClosed = () => {
    setIsCreateTicketModalOpen(false)
  }
  console.log(data2)

  useEffect(() => {
    if (data2?.getTicketbyStatus) {
      setTicketData(data2?.getTicketbyStatus?.tickets)
    }
  }, [data2])

  const getStatusLabel = (statusId: number) => {
    switch (statusId) {
      case 1:
        return 'Open'
      case 3:
        return 'Resolved'
      case 2:
        return 'In-Progress'
      // case 4:
      //   return 'Pending'
      case 6:
        return 'Assign'
      case 7:
        return 'Unassign'
      default:
        return ''
    }
  }

  const getCategoryLabel = (categoryId: number) => {
    switch (categoryId) {
      case 1:
        return 'Support'
      case 2:
        return 'Development'
      case 3:
        return 'Service'
      default:
        return ''
    }
  }

  const headMap = [
    'S.No',
    'Ticket Number',
    'Title',
    'Description',
    'Resolution',
    'Status',
    'Priority',
    'Category',
    'Assigned',
    'Action'
  ]

  const getPriorityLabel = (priorityId: any) => {
    switch (priorityId) {
      case 1:
        return { label: 'High', className: 'high-priority' }
      case 2:
        return { label: 'Low', className: 'low-priority' }
      case 3:
        return { label: 'Medium', className: 'medium-priority' }
      default:
        return { label: '', className: '' }
    }
  }

  const handleSearchInputChange = (value: any) => {
    let searchValue = value
    if (searchValue.length > 0) {
      setSearchQuery(searchValue)
    } else {
      setSearchQuery('')
    }
  }

  const handleDropdownChange = (selectedItem: any) => {
    if (selectedItem?.label === 'null') {
      setSelectedStatus(null)
    } else {
      setSelectedStatus(selectedItem?.label)
    }
  }

  const handlePriority = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value === 'null' ? null : event.target.value
    setPriority(value)
  }

  // Pagination
  const totaltickets: any = data2?.getTicketbyStatus?.ticketcount
  const totalPages = Math.ceil(totaltickets / showEnteries)

  // const indexOfLastticket = currentPage * showEnteries
  const indexOfFirstticket = currentPage * showEnteries - showEnteries
  // const currentticket = ticketData.slice(indexOfFirstticket, indexOfLastticket)

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber)
  }

  const nextPage = () => {
    if (totalPages > 0) {
      setCurrentPage((prevPage: number) => prevPage + 1)
    }
  }

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage: number) => prevPage - 1)
    }
  }

  // Generate snake handle pagination numbers
  const generatePaginationNumbers = () => {
    const numbers = []
    const maxVisibleNumbers = 4 // Maximum visible pagination numbers

    if (totalPages <= maxVisibleNumbers) {
      // If total pages are less than or equal to max visible numbers, show all
      for (let i = 1; i <= totalPages; i++) {
        numbers.push(i)
      }
    } else {
      const middleIndex = Math.ceil(maxVisibleNumbers / 2) // Middle index of the pagination numbers
      let startPage = currentPage - middleIndex + 1
      let endPage = currentPage + middleIndex - 1

      if (startPage < 1) {
        // If start page is less than 1, adjust start and end page accordingly
        endPage = startPage + maxVisibleNumbers - 1
        startPage = 1
      } else if (endPage > totalPages) {
        // If end page is greater than total pages, adjust start and end page accordingly
        startPage = endPage - maxVisibleNumbers + 1
        endPage = totalPages
      }

      for (let i = startPage; i <= endPage; i++) {
        numbers.push(i)
      }
    }

    return numbers
  }

  const menu = (
    <Menu>
      {items && items.length > 0
        ? items.map((item: any) => (
            <Menu.Item
              key={item.key}
              onClick={() => handleDropdownChange(item)}
              disabled={item.label === selectedStatus}
            >
              {item?.title}
            </Menu.Item>
          ))
        : null}
    </Menu>
  )

  return (
    <div className='card mb-5 mb-xl-8'>
      <div className='d-flex justify-content-between'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Tickets</span>
          </h3>
        </div>
      </div>
      <div className='px-4 py-2'>
        <TicketCount />
      </div>
      <div className='d-flex ms-10'>
        <input
          placeholder='Search Ticket no., Title, Description'
          style={{
            padding: '10px',
            border: '1px solid rgb(215, 209, 209)',
            width: '35%',
            minWidth: '100px',
            borderRadius: '10px'
          }}
          value={searchQuery}
          onChange={(e) => handleSearchInputChange(e.target.value)}
        />
        <div className='d-flex align-items-center justify-content-end flex-grow-1 gap-3 me-10'>
          <span>
            <select
              className='form-control text-primary bg-light-primary'
              name='priority'
              id='priority'
              style={{
                width: '140px',
                height: '42px',
                borderRadius: '5px',
                border: '#f1faff'
              }}
              value={priority}
              onChange={handlePriority}
            >
              <option value='null' selected>
                Select Priority
              </option>
              <option value='LOW'>Low</option>
              <option value='MEDIUM'>Medium</option>
              <option value='HIGH'>High</option>
              {/* <option value='null'>Clear</option> */}
            </select>
          </span>
          <span className='w-30 me-4'>
            <Dropdown overlay={menu} trigger={['click']}>
              <i
                className='bi bi-filter btn btn-light-primary'
                style={{
                  fontSize: '25px',
                  flex: '1',
                  textAlign: 'center',
                  boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                  borderRadius: '10px',
                  padding: '3px 10px'
                }}
              ></i>
            </Dropdown>
          </span>
          <button onClick={createTicketModalOpen} className='btn btn-light-primary'>
            + Create Ticket
          </button>
        </div>
      </div>
      {loading1 ? (
        <LoadingSpinner />
      ) : (
        <div className='card-body py-3'>
          {!!ticketData && ticketData?.length > 0 ? (
            <div className='table-responsive border border-muted rounded-2'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bolder fs-6 text-primary bg-light-primary'>
                    {headMap?.map((el: string, index: number) => (
                      <th className='ps-4 min-w-100px' key={uuidv4()} scope='col'>
                        {el}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {ticketData?.map((curEl: any, index: any) => (
                    <React.Fragment key={uuidv4()}>
                      <tr>
                        <td className='ps-4 cursor-pointer fw-bold'>
                          {indexOfFirstticket + index + 1}
                        </td>
                        <td className='ps-4 cursor-pointer fw-bold'>{curEl?.ticketNumber}</td>

                        <td className='ps-4 cursor-pointer fw-bold'>{curEl?.title}</td>
                        <td
                          className='ps-4 cursor-pointer fw-bold'
                          data-toggle='tooltip'
                          title={curEl?.description}
                        >
                          {curEl?.description && curEl.description.length > 250
                            ? `${curEl.description.slice(0, 250)}...`
                            : curEl?.description}
                        </td>

                        <td className='ps-4 cursor-pointer fw-bold'>
                          {!!curEl?.resolution ? curEl?.resolution : 'NA'}
                        </td>
                        <td className='ps-4 cursor-pointer fw-bold'>
                          {getStatusLabel(curEl?.StatusId)}
                        </td>

                        <td
                          className={`ps-4 cursor-pointer fw-bold ${
                            getPriorityLabel(curEl?.PriorityId).className
                          }`}
                        >
                          {getPriorityLabel(curEl?.PriorityId).label}
                        </td>
                        <td className='ps-4 cursor-pointer fw-bold'>
                          {getCategoryLabel(curEl?.TypeId)}
                        </td>
                        <td>
                          {curEl?.supportEngineerName ? curEl?.supportEngineerName : 'Not Assigned'}
                        </td>

                        <td
                          className='ps-4 cursor-pointer text-primary fw-bold'
                          onClick={() => {
                            openEditModal(curEl)
                          }}
                        >
                          <i className='bi bi-pencil-fill me-1'></i> Edit
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <Empty />
          )}
          {/* Pagination */}
          {ticketData?.length > 0 && (
            <div className='row'>
              <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>
              <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
                <div
                  className='dataTables_paginate paging_simple_numbers'
                  id='kt_table_users_paginate'
                >
                  <ul className='pagination pb-3'>
                    <li
                      className={`paginate_button page-item ${currentPage === 1 ? 'disabled' : ''}`}
                    >
                      <button
                        type='button'
                        aria-controls='kt_table_users'
                        data-dt-idx='0'
                        className='btn primary page-link'
                        onClick={prevPage}
                      >
                        <i className='previous'></i>
                      </button>
                    </li>
                    {generatePaginationNumbers().map((pageNumber) => (
                      <li
                        key={pageNumber}
                        className={`paginate_button page-item ${
                          currentPage === pageNumber ? 'active' : ''
                        }`}
                      >
                        <button
                          type='button'
                          aria-controls='kt_table_users'
                          data-dt-idx={pageNumber}
                          className='btn primary page-link'
                          onClick={() => paginate(pageNumber)}
                        >
                          {pageNumber}
                        </button>
                      </li>
                    ))}
                    <li
                      className={`paginate_button page-item ${
                        currentPage === totalPages ? 'disabled' : ''
                      }`}
                    >
                      <button
                        type='button'
                        aria-controls='kt_table_users'
                        data-dt-idx='0'
                        className='btn primary page-link'
                        onClick={nextPage}
                      >
                        <i className='next'></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <Modal
        title='Create Ticket'
        open={isCreateTicketModalOpen}
        onCancel={createTicketModalClosed}
        footer={null}
        destroyOnClose
      >
        <CreateTicketAdmin closeModal={createTicketModalClosed} refetch={refetch1} />
      </Modal>
      <Modal
        title='Edit Ticket'
        open={isEditModalOpen}
        onCancel={closeEditModal}
        footer={null}
        width={700}
        destroyOnClose
      >
        <EditTicketModal
          closeModal={closeEditModal}
          editTicketData={editTicketData}
          getCategoryLabel={getCategoryLabel}
        />
      </Modal>
    </div>
  )
}

export default TicketsData
